import {get,post} from "./request"
// 获取访问量接口
export const statisticalData = data => get('/statisticalData',data);
// 获取首页轮播图
export const getInformationPicList = data => get('/getInformationPicList',data);
// 获取资讯
export const getInformationList = data => get('/getInformationList',data);
// 资讯详情
export const getInformationInFo = data => get('/getInformationInFo',data);
// 名师堂
export const getTeacherList = data => get('/getTeacherList',data);
// 名师堂详情
export const getTeacherInFo = data => get('/getTeacherInFo',data);
// 友情链接
export const getBlogrollTree = data => get('/getBlogrollTree',data);
// 资源列表获取资源分类
export const getResourceList = data => get('/getResourceList',data);
// 资源列表获取专业类别
// export const getSpecialtyTypeTree = data => get('/getSpecialtyTypeTree',data);
// 资源列表获取专业类别
export const getSpecialtyList = data => get('/getSpecialtyList',data);
// 获取资源类型
export const getFileTypeList = data => get('/getFileTypeList',data);
// 获取资源大类
export const getFileCategoryList = data => get('/getFileCategoryList',data);
// 获取专业类别
export const getListTreeData = data => get('/getListTreeData',data);
// 获取手机验证码
export const getCode = data => get('/getCode',data);
// 注册
export const registered = data => post('/registered',data);
// 用户登录
export const login = data => get('/login',data);
// 获取个人信息
export const getUserInFo = data => get('/getUserInFo',data);
// 修改个人信息
export const updateUser = data => post('/updateUser',data);
// 退出登录
export const logout = data => get('/logout',data);
// 忘记密码
export const forgetPassword = data => get('/forgetPassword',data);
// 忘记密码发送验证码
export const retrievePassword = data => get('/retrievePassword',data);

// 获取学校列表
export const getSchoolList = data => get('/getSchoolList',data);
// 获取资源列表
export const getPlatformIndexList = data => get('/getPlatformIndexList',data);
// 获取首页资源库
export const getResourceCount = data => get('/getResourceCount',data);
// 获取资源详情
export const getResourceInFo = data => get('/getResourceInFo',data);
// // 获取下载链接
// export const getUrl = data => get('/getUrl',data);
// 获取所有课程列表
export const getPlatFileList = data => get('/getPlatFileList',data);
// 获取专业资源页面分类接口
export const getCategoryList = data => get('/getCategoryList',data);
// 获取专业资源页面分类接口
export const getTeacherFileList = data => get('/getTeacherFileList',data);
// 浏览文件
export const previewResource = data => get('/previewResource',data);
// 下载文件
export const downloadResource = data => get('/downloadResource',data);
// 获取栏目类型
export const getCplumnList = data => get('/getCplumnList',data);
// 获取页脚信息
export const getWebFooter = data => get('/getWebFooter',data);
// 获取关于我们
export const getAboutUs = data => get('/getAboutUs',data);
// 获取页脚信息
export const getSchoolData = data => get('/getSchoolData',data);







